var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { T } from '../helpers/i18n';
import { Input } from '../elements';
import { round } from '../helpers/Format';
var Calculator = /** @class */ (function (_super) {
    __extends(Calculator, _super);
    function Calculator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            priceTax: 0,
            priceCalc: 0
        };
        _this.handleChangeCalc = function (event) {
            var priceTax = event.target.value;
            var priceCalc = _this.props.taxValue ? _this.calculate(priceTax, _this.props.taxValue) : 0;
            _this.setState({ priceTax: priceTax, priceCalc: priceCalc });
        };
        _this.calculate = function (priceTax, taxValue) {
            return (priceTax / (taxValue.value + 1));
        };
        return _this;
    }
    Calculator.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        // recalculo sólo cuando cambia props.taxValue
        if (prevProps.taxValue !== this.props.taxValue) {
            var calc = {
                target: {
                    value: this.state.priceTax
                }
            };
            this.handleChangeCalc(calc);
        }
    };
    Calculator.prototype.render = function () {
        var priceCalc = this.state.priceCalc;
        var styles = this.props.styles;
        return (React.createElement("div", { style: __assign({ display: 'block', marginLeft: '20px', marginRight: '20px', marginTop: '10px' }, styles) },
            React.createElement("label", { style: {
                    fontSize: 'large',
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    marginLeft: '20px'
                } }, T('calculadora_precios_sin_iva')),
            React.createElement("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingLeft: '30px', paddingRight: '20px' } },
                React.createElement(Input, { style: { flex: 1, paddingRight: '40px' }, type: 'number', label: T('priceWithTax'), onChange: this.handleChangeCalc }),
                React.createElement(Input, { style: { flex: 1, paddingLeft: '40px' }, type: 'number', label: T('priceWithoutTax'), value: round(priceCalc, 4) }))));
    };
    return Calculator;
}(Component));
export default Calculator;



//////////////////
// WEBPACK FOOTER
// ./src/components/Calculator.tsx
// module id = 153
// module chunks = 0